// src/components/progress/ProgressBar.tsx
import React from 'react';
import './ProgressBar.scss';
import { Spinner } from '../spinner/Spinner';

interface ProgressBarProps {
    timeRemaining: string;
    processedItems: number;
    totalItems: number;
    percentComplete: number;
    size?: number;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
    timeRemaining,
    processedItems,
    totalItems,
    percentComplete,
    size = 20
}) => {
    const timeDisplay = timeRemaining === '00:00' ? '00:00' : `-${timeRemaining}`;
    const showSpinner = percentComplete === 0;

    return (
        <div className="progress-bar">
            <div className="progress-info left">
                <span className="time-remaining">{timeDisplay}</span>
            </div>
            <div className="progress-track">
                <div
                    className="progress-fill"
                    style={{ width: `${percentComplete}%` }}
                />
                {showSpinner && (
                    <div className="progress-indicator">
                        <Spinner size={size} />
                    </div>
                )}
            </div>
            <div className="progress-info right">
                <span className="items-count">{processedItems} / {totalItems}</span>
            </div>
        </div>
    );
};